import React, {Component} from 'react'

class Look extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedId: props.selectedId,
      json: props.json,
    }
    this.lookRef = React.createRef()
    this.setSelectedId.bind(this)
    this.setOpen.bind(this)
  }

  setSelectedId = (selectedId) => {
    this.props.setSelectedId(selectedId)
  }

  setOpen = (open) => {
    this.props.setOpen(open)
  }

  render() {
    return (
      <div className='flex grow items-center justify-center' ref={this.lookRef}>
        <div className='py-5 lg:py-20 flex flex-col items-center justify-center w-full lg:w-[30rem] px-4 lg:max-w-full'>
          <h2 className='mb-10 text-base'>Look { this.props.selectedId }</h2>
          {
            this.state.json.looks[this.props.selectedId - 1]?.products?.map((product, index) =>
              <details 
                className={`w-full ${index == 0 ? 'border-t' : ''} border-b border-tb-black`}
                key={`${this.state.json?.subpath}-${this.props.selectedId}-proudct-${index}`}
                open={index == 0}
              >
                <summary className='cursor-pointer text-base text-left py-2'>
                  { index + 1 }
                  &nbsp;
                  { product.product.title }
                </summary>
                <div className='flex gap-4 pb-4'>
                  <div className='flex gap-4 w-full'>
                    <div className='w-24'>
                      {
                        product.product.featured_image && <img className='w-full mb-4' src={product.product.featured_image} alt={product.product.title} />
                      }
                      <a href={`${Shopify.routes.root}products/${product.product.handle}`} className='underline text-xs'>
                        More Details
                      </a>
                    </div>
                    <div className='w-[calc(100%-7rem)]'>
                      <div
                        className=""
                        data-plp-item={product.product.id}
                        data-inited="false"
                        lazyload="true"
                        look="true"
                        />
                      {/* <div className="" data-plp-regular-price>
                        {
                          product.product.compare_at_price && product.product.compare_at_price > product.product.price &&
                          <span className="text-fourth-grey">
                            { money(product.product.compare_at_price, true) }
                          </span>
                        }
                      </div>
                      {
                        product.private_sale_price && product.product.price > product.private_sale_price &&
                        <div className="!hidden" data-pdp-private-price>
                          { money(product.private_sale_price, true) }
                          <del className="text-fourth-grey">
                            { money(product.product.price, true) }
                          </del>
                        </div>
                      } */}
                    </div>
                  </div>
                </div>
              </details>
            )
          }

          <div className='flex items-center gap-4 mt-10'>
            <button 
              className={`rotate-180 cursor-pointer ${this.props.selectedId == 1 ? 'opacity-20' : ''}`}
              disabled={this.props.selectedId == 1} 
              dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-chevron-alt'] }}
              onClick={e => {
                const newIndex = this.props.selectedId - 1
                this.setSelectedId(newIndex)
              }} 
            />

            <button className='grid grid-cols-3 gap-0.5'
              onClick={e => {this.setOpen(false)}}
            >
              {
                [1,2,3,4,5,6,7,8,9].map((num, index) =>
                  <div className='bg-tb-black w-1.5 h-1.5' key={`${this.state.json?.subpath}-${this.props.selectedId}-square-${index}`}></div>
                )
              }
            </button>
            <button 
              dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-chevron-alt'] }}
              className={`cursor-pointer ${this.props.selectedId >= this.state.json?.looks?.length ? 'opacity-20' : ''}`}
              disabled={this.props.selectedId >= this.state.json?.looks?.length}
              onClick={e => {
                const newIndex = this.props.selectedId + 1
                this.setSelectedId(newIndex)
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Look